import _ from 'lodash';
import {createSelector} from 'reselect';

import {makeGetAppPanel} from '../appPanelSelectors';
import {BannerTypesEnum} from './bannersState';

/*
 * Selectors.
 */

export function makeGetVisibleBannersForPanel() {
  return createSelector(makeGetAppPanel(), (panel) =>
    _(panel.visibleBannerUids)
      .map((uid) => panel.banners[uid])
      .compact()
      .value(),
  );
}

export function makeGetUndoBannersForPanel() {
  return createSelector(makeGetAppPanel(), (panel) =>
    _(panel.undoBannerUids)
      .map((uid) => panel.banners[uid])
      .compact()
      .map((b) => b.type === BannerTypesEnum.UNDO && b)
      .compact()
      .value(),
  );
}

export function makeGetErrorBannersForPanel() {
  return createSelector(makeGetAppPanel(), (panel) =>
    _(panel.errorBannerUids)
      .map((uid) => panel.banners[uid])
      .compact()
      .map((b) => b.type === BannerTypesEnum.ERROR && b)
      .compact()
      .value(),
  );
}
